import { combineReducers } from 'redux'
import all from './all'


export default combineReducers({ all })
